import React from 'react';

const GoogleIcon = () => /* @__PURE__ */ React.createElement(
  "svg",
  {
    width: "28",
    height: "22",
    viewBox: "0 0 28 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  },
  /* @__PURE__ */ React.createElement("g", { clipPath: "url(#clip0_2398_12850)" }, /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M1.91237 21.4989H6.36631V10.6822L0.00354004 5.91016V19.5901C0.00354004 20.6463 0.859332 21.4989 1.91237 21.4989Z",
      fill: "#4285F4"
    }
  ), /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M21.6364 21.4989H26.0903C27.1465 21.4989 27.9991 20.6432 27.9991 19.5901V5.91016L21.6364 10.6822",
      fill: "#34A853"
    }
  ), /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M21.6364 2.40985V10.6815L27.9991 5.90937V3.36427C27.9991 1.00368 25.3045 -0.342046 23.4179 1.07367",
      fill: "#FBBC04"
    }
  ), /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M6.36487 10.6818V2.41016L14.0002 8.13665L21.6355 2.41016V10.6818L14.0002 16.4082",
      fill: "#EA4335"
    }
  ), /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M0.00354004 3.36476V5.90986L6.36631 10.6819V2.41034L4.58473 1.07416C2.69499 -0.341558 0.00354004 1.00417 0.00354004 3.36476Z",
      fill: "#C5221F"
    }
  )),
  /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("clipPath", { id: "clip0_2398_12850" }, /* @__PURE__ */ React.createElement(
    "rect",
    {
      width: "27.9962",
      height: "20.9971",
      fill: "white",
      transform: "translate(0.00195312 0.501465)"
    }
  )))
);

export { GoogleIcon };
//# sourceMappingURL=GoogleIcon.js.map
